import {Button, Col, Form, Modal, Row, Space, Table, notification} from "antd";
import Icons from "assets/icons";
import TableInputAdd from "components/common/TableInputAdd/TableInputAdd";
import React, {useEffect, useState} from "react";
import {columnModaTabPay} from "./ModalTabPay.config";
import dataModalTabPay from "__mocks__/dataModalTabPay";
import {payService} from "api";
import {useAppSelector} from "redux/hooks";
import Notification from "components/common/notification/notification";

const ModalTabPay = ({isShowModal, handleOk, handleCancel, apiCalled}) => {
  const [data, setData] = useState(dataModalTabPay);
  const [formData] = Form.useForm();
  const [loadingTable, setLoadingTable] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const id = useAppSelector(state => state.reduxCommon.id2);
  // console.log("id modal", id);

  const onFinish = value => {
    // console.log("value", value);
  };

  useEffect(() => {
    if (apiCalled) {
      try {
        const response = payService.getListPrescriptionById(id).then(res => {
          // notification.success({message: "Lấy dữ liệu thành công"});
          const newData = res.data.data.map(item => ({
            key: item.id,
            code: item.maThuoc,
            name: item.tenThuoc,
            dv: item.donViTinh,
            sl: item.soLuong,
            price: item.donGia,
            type: item.loaiSanPham,
            slReal: item.soLuongThuc,
            vat: item.thueVat,
            money: item.thanhTien,
            number: item.lieuDung,
            note: item.ghiChu,
          }));
          setData(newData);
          setLoadingTable(false);
          setTotalPage(res.data.total);
        });
      } catch (error) {
        // Notification("error", "Đã có lỗi xảy ra khi lấy dữ liệu");
        
        setLoadingTable(false);
      }
    }
  }, [apiCalled]);

  formData.setFieldsValue({
    // formTable: dataModal,
    // nameDoctor: doctor
  });
  return (
    <Modal
      title="Đơn thuốc"
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={"80%"}
      className="modal-tab-pay"
      footer=""
    >
      <div className="table-results">
        <Form form={formData} onFinish={onFinish}>
          <Space direction="vertical" size={"middle"} style={{width: "100%"}}>
            <Form.Item name={"formTable"}>
              <Row gutter={[16, 8]} justify={"space-between"}>
                <Col span={24}>
                  <Table
                    bordered
                    dataSource={data}
                    columns={columnModaTabPay}
                    loading={loadingTable}
                  />
                </Col>
              </Row>
            </Form.Item>
            <Row gutter={[16, 8]} justify={"end"}>
              <div>
                <Button
                  key="cancel"
                  type="primary"
                  danger
                  onClick={handleCancel}
                >
                  Huỷ bỏ
                </Button>
                ,
                <Button
                  key="submit"
                  type="primary"
                  htmlType="submit"
                  icon={<Icons.save rev={0} />}
                  onClick={handleCancel}
                >
                  Lưu lại
                </Button>
              </div>
            </Row>
          </Space>
        </Form>
      </div>
    </Modal>
  );
};

export default ModalTabPay;
